/**
 * A child's age from their 出生年月 ('YYYY-MM') — the frontend twin of
 * backend/utils/childAge.js, for display. Keep the two in step.
 */
import { getTodayInChina } from '../../utils/timestampUtils';

/** Whole years old today (China); the birthday month counts as had. Null if unknown. */
export function ageInYears(birthYm, todayChina = getTodayInChina()) {
  if (!birthYm) return null;
  const [by, bm] = birthYm.split('-').map(Number);
  const [ty, tm] = todayChina.split('-').map(Number);
  return ty - by - (tm < bm ? 1 : 0);
}

/** '2018年9月 · 8岁' */
export function formatBirthYm(birthYm, todayChina) {
  if (!birthYm) return '';
  const [y, m] = birthYm.split('-').map(Number);
  const age = ageInYears(birthYm, todayChina);
  return `${y}年${m}月${age != null && age >= 0 ? ` · ${age}岁` : ''}`;
}

/**
 * What a parent should know the age changes. Mirrors listeningModeForAge in the
 * backend (6 and under pick, 7–8 letter tiles, 9+ type).
 */
export const BIRTH_YM_EXPLAINER =
  '我们会按年龄安排每日听力的题型：6岁及以下听音选词，7–8岁用字母块拼写，9岁以上听音打字。';
